__turbopack_context__.v({
  "Loading": "style-module__DT2SoG__Loading",
});
